export default "__VITE_ASSET__CjxwDf2d__"